import * as Effects from './effects';
import * as FeaturesNavigation from './features-navigation';
import * as Feedback from './feedback';
import * as Filetype from './filetype';
import * as Interaction from './interaction';
import * as Logos from './logos';
import * as MediaPlayback from './media-playback';
import * as Permissions from './permissions';
import * as Sports from './sports';
import * as Technology from './technology';
import * as UiControls from './ui-controls';
import * as User from './user';
import * as VideoFeatures from './video-features';

export default {
  ...Effects,
  ...FeaturesNavigation,
  ...Feedback,
  ...Filetype,
  ...Interaction,
  ...Logos,
  ...MediaPlayback,
  ...Permissions,
  ...Sports,
  ...Technology,
  ...UiControls,
  ...User,
  ...VideoFeatures,
};



// WEBPACK FOOTER //
// ./src/icon/svgs/index.js